import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from '@azure/msal-react';
import { AuthProvider } from './auth/AuthProvider';
import { msalInstance } from './auth/msal';
import { TdsSpinner } from "@scania/tegel-react";

// Splash with Tegel spinner
const Splash = () => (
  <div style={{
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f7f7f7"
  }}>
    <TdsSpinner size="md" variant="standard" />
  </div>
);

// Async bootstrap: wait for MSAL to initialize BEFORE rendering
(async () => {
  await msalInstance.initialize();

  const container = document.getElementById('root');
  if (!container) throw new Error('Root container #root not found');

  const root = createRoot(container as HTMLElement);

  // Render the splash (spinner) immediately
  root.render(<Splash />);

  // After MSAL is ready, render the real app
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </MsalProvider>
    </React.StrictMode>
  );
})();

reportWebVitals();